import { distanceCalculateArial } from "../api/DistanceCalculator";
import { IsNullUndefine } from "./helper";
import { isPointInPolygon } from 'geolib';

export function CheckDeliveryAvailable(store: any) {
  return store?.store_delivery_radius?.sort(
    (a: any, b: any) => b?.to - a?.to
  )?.[0]?.to;
}
export function CheckDeliveryPrice(distance: number, store: any) {
  return (
    store?.store_delivery_radius?.find(
      (item: any) => item.from <= distance && item.to >= distance
    )
  );
}

// @@ for store delivery radios 

export function CheckStoreRadiousDeliveryAvailable(data: any, store: any) {
  const distance = distanceCalculateArial({ lat1: data?.latitude, lat2: store?.lattitude, lon1: data?.longitude, lon2: store?.longitude, })
// console.log('distance', distance, store)
  if (distance && distance?.dis) {
    let storeDelivery = store?.store_delivery_radius;
    let checkStoreDelivery = storeDelivery?.find((i: any) => i.to >= distance?.dis);
   // console.log('checkStoreDelivery', checkStoreDelivery)
    if (checkStoreDelivery) {
      return { status: true, distance: distance }
    }
  }
  return { status: false, distance: distance }
}



function FixedValue(value: any) {
  // return value?.toFixed(3)
  return value;
}
const isPointInsidePolygon = (lat:any, lon:any, polygon:any) => {
  return isPointInPolygon({ latitude: lat, longitude: lon }, polygon);
};


export function CheckStoreAreaDeliveryAvailable(searchData: any, selectedStore: any) {
  let lat = FixedValue(searchData?.lat);
  let lng = FixedValue(searchData?.lng);
  let selectedStoreArea = selectedStore?.map_store_delivery_areas || [];
  let matchedAreaData = selectedStoreArea?.map?.((area: any) => {
    let formatPolygon=area?.coordinates.map((i:any)=>{
      return {
        latitude:i.lat,
        longitude:i.long
      }
    })
    // console.log('formatPolygon',formatPolygon)
    let isExist=isPointInsidePolygon(lat,lng,formatPolygon)
    // const findCoordinates = area?.coordinates?.find((coord: any) => {
    //   let cLat = FixedValue(coord.lat);
    //   let cLng = FixedValue(coord.long);
    //   console.log('clat', cLat, cLng, lat, lng)
    //   return cLat == lat && cLng == lng;
    // });
    // return isExist==true
   

    // return {
    //   ...area,
    //   match: findCoordinates,
    // }
    // console.log("isExist",isExist,lat,lng,area?.coordinates,formatPolygon)
      return {
      ...area,
      match:isExist ? area?.coordinates[0]:undefined,
    }
  })?.find((i: any) => !IsNullUndefine(i?.match))

  // console.log("matchedAreaDaaata", searchData, matchedAreaData, selectedStoreArea)
  return {
    status: matchedAreaData ? true : false,
    matchedAreaData: matchedAreaData || {}
  };
}
